module.exports = __webpack_public_path__ + "static/img/10.2a24acc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/11/zh/10.png
// module id = vsSS
// module chunks = 0